import { Form, Input, Modal, Select } from "antd";
import { useEffect } from "react";
import { TASK_STATUS_OPTIONS } from "../constants";
import { useUpdateTaskStatus } from "../hooks/useTasks";
import { useTasksStore } from "../store/tasks.store";
import type { UpdateTaskStatusRequest } from "../types";

export function TaskStatusModal() {
	const [form] = Form.useForm<UpdateTaskStatusRequest>();
	const { statusModalOpen, selectedTask, closeStatusModal } = useTasksStore();

	const { mutate: updateStatus, isPending } = useUpdateTaskStatus();

	useEffect(() => {
		if (statusModalOpen && selectedTask) {
			form.setFieldsValue({
				status: selectedTask.status,
				comment: undefined,
			});
		}
	}, [statusModalOpen, selectedTask, form]);

	const handleClose = () => {
		closeStatusModal();
		form.resetFields();
	};

	const handleSubmit = () => {
		form
			.validateFields()
			.then((values) => {
				if (!selectedTask) {
					return;
				}
				updateStatus(
					{
						id: selectedTask.id,
						data: {
							status: values.status,
							comment: values.comment || undefined,
						},
					},
					{ onSuccess: handleClose }
				);
			})
			.catch(() => {
				// Validation failed - Form shows errors inline
			});
	};

	return (
		<Modal
			title={`Statusni yangilash: ${selectedTask?.title ?? ""}`}
			open={statusModalOpen}
			onCancel={handleClose}
			onOk={handleSubmit}
			confirmLoading={isPending}
			okText="Saqlash"
			cancelText="Bekor qilish"
			destroyOnHidden
		>
			<Form form={form} layout="vertical" requiredMark={false} className="mt-4">
				<Form.Item
					name="status"
					label="Status"
					rules={[{ required: true, message: "Statusni tanlang" }]}
				>
					<Select options={TASK_STATUS_OPTIONS} placeholder="Statusni tanlang" />
				</Form.Item>
				<Form.Item name="comment" label="Izoh (ixtiyoriy)" rules={[{ max: 500 }]}>
					<Input.TextArea rows={3} placeholder="Izoh..." />
				</Form.Item>
			</Form>
		</Modal>
	);
}
